<template>
  <div class="logAudit">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-conts module1-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
            <div class="view-left wow bounceInUp">
              <h1>XspeederLog_</h1>
              <h2>神行者日志_</h2>
              <p>是基于公司多年经验推出的基于大数据架构的新一代日志审计系统，针对客户部署的神行者路由流控设备实现日志数据的高效采集、统一管理、集中存储、统计分析。</p>
              <div class="line">
                <span>1、系统基于SOA架构设计 丨 系统采用B/S管理模式</span>
              </div>
              <div class="line">
                <div class="line-label">
                  <span>2、系统由8个子系统构成</span>
                </div>
                <div class="line-info">
                  <p>日志采集丨日志处理丨日志管理丨事件监测</p>
                  <p>日志存储丨统计分析丨告警响应丨系统管理</p>
                </div>
              </div>
              <div class="line">
                <span>3、各子系统相互耦合+协作 丨 同时保证整个系统稳定+高效</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
            <div class="view-right wow fadeIn">
              <div class="img-box">
                <img :src="require('@/assets/images/logAudit-module1-1.jpg')" />
              </div>
              <p>如针对排名、分布、趋势和相似性分析，提供IP 轨迹、TOP域名、应用流量流向图、URL 地图、TOP 用户、连接可视化分析和DNS 可视化分析等为代表的分析工具，并可协助运营商高效统一管理网络日志并为安全事件的事后取证提供依据。</p>
            </div>
          </el-col>
        </div>
        <div class="module-conts module2-conts">
          <div class="module-title">
            日志系统政策需求
          </div>
          <div class="conts-view">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="view-left wow zoomIn">
                <h4>政策背景</h4>
                <p>根据《网络安全法》第二十一条（三）项：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月；第五十九条之规定，决定给予该公司警告处罚，并责令限期十五日内进行整改。</p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <div class="view-right">
                <p><span>自2007年网络安全等级保护制度实施至今，已从等保1.0时代进入等保2.0时代，再加之2017年6月《中华人民共和国网络安全法》颁布实施</span>，中国的网络安全发生了突破性进展，不仅体系发生了大升级，而且网络安全标准也从制度上升为法律，变得空前重要。<span>这套制度标准的实施为信息系统安全开辟了一条可落地可操作的道路，不仅为各信息系统提供体系化的指导，根据各自责任落实相应技术措施</span>；同时为落实信息系统安全工作提供方向和依据，明确法律法规要求，让安全工作有法可依；还致力于落实保障个人信息、资金等安全，为个人隐私提供保护伞。</p>
              </div>
            </el-col>
          </div>
          <div class="img-box">
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="conts wow slideInUp" data-wow-delay="0.1s">
                <img :src="require('@/assets/images/logAudit-module2-1.png')" />
                <p>运营商</p>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="conts wow slideInUp" data-wow-delay="0.3s">
                <img :src="require('@/assets/images/logAudit-module2-2.png')" />
                <p>大型企业</p>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="conts wow slideInUp" data-wow-delay="0.2s">
                <img :src="require('@/assets/images/logAudit-module2-3.png')" />
                <p>中型企业</p>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="conts wow slideInUp" data-wow-delay="0.4s">
                <img :src="require('@/assets/images/logAudit-module2-4.png')" />
                <p>中小型企业</p>
              </div>
            </el-col>
          </div>
          <div class="infos-box">
            <p>针对网络安全法规定的 <span>日志留存要求</span></p>
            <p><span>神行者</span> 已经推出了成熟的适用与运营商、大型企业、中型企业、中小企业的完整日志安全合规解决方案。</p>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module3-conts">
          <div class="module-title">
            神行者日志系统功能
          </div>
          <div class="conts-view">
            <img :src="require('@/assets/images/logAudit-module3-1.jpg')" />
            <h3>1.常规日志输出功能</h3>
            <p>源IP目的IP NAT日志、URL查询、DNS查询、微信日志、QQ日志、虚拟身份、游戏日志、移动终端、网贷情况、节点日志、图片浏览、文件下载、用户认证、百度贴吧、GPS记录等。</p>
            <h3>2.流量监控分析</h3>
            <p>实现对网络进行流量可视化和应用精细化，将每一个连接的具体应用呈现出来，便于网络管理者进行分析、定位、处理和优化，通过流量可视化管理，可以看到学校上行、下行流量趋势以及各种协议占用带宽的百分百等信息。对网络出口的TOP IP 流量、TOP 并发 IP 数、TOP 应用均可实现统计分析呈现。从流量大小、连接数多少、应用的访问量等多维度呈现网络现状，记录网络大趋势。</p>
            <h3>3.大数据分析</h3>
            <p>神行者路由具备计算机领域内先进的数据包处理技术，能识别95%以上的应用，实现精准流量分析，生成详细的日志数据。结合神行者日志可以实现海量PB级别的数据存储分析。</p>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          神行者日志系统优势
        </div>
        <div class="module4-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}">
            <div class="item">
              <div class="card">
                <div class="tag">1</div>
                <img :src="require('@/assets/images/logAudit-module4-1.png')" />
                <h4>海量日志秒级查询</h4>
                <p>神行者独有的分布式结构化存储只要存储空间足够，即使PB级的数据量也能应付，<span>10亿数量级别的检索只需要5-20秒即可获得结果</span>。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="item">
              <div class="card">
                <div class="tag">2</div>
                <img :src="require('@/assets/images/logAudit-module4-2.png')" />
                <h4>精细的日志采集粒度</h4>
                <p>对比并不具备足够DPI能力的传统网关类设备，而七层应用日志，<span>可提供网络内任意一个IP的深层信息，精确到每时每刻每IP每条连接</span>。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="item">
              <div class="card">
                <div class="tag">3</div>
                <img :src="require('@/assets/images/logAudit-module4-3.png')" />
                <h4>信息安全与数据高效处理</h4>
                <p>支持对原始安全信息数据进行全文检索，支持单一条件、多条件检索查询，查询结果即查即显，支持查询结果二次查询。<span>实时流量监视，轻松了解系统处理速度</span>。</p>
              </div>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          三大优势介绍
        </div>
        <div class="module5-conts">
          <div class="module-view">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:14}">
              <div class="view">
                <div class="view-title">
                  <h3>01 海量日志秒级查询</h3>
                  <p>MASSIVE LOG SECOND QUERY</p>
                </div>
                <div class="infos-box">
                  <p>对于规模较大的运营商，每日日志量动辄几百G，而、加上公安部82号令、151号令要求日志必须保留180天以上，这对海量日志的存储和检索都提出了严峻的挑战。传统的关系数据库存储已经完全满足不了要求，而存储为文件的方式不利于检索。</p>
                  <p><span>神行者独有的分布式结构化存储</span>完美的解决了这个问题，只要存储空间足够，即使PB级的数据量也能应付，10亿数量级别的检索只需要5-20秒即可获得结果。</p>
                  <div class="tag-box">
                    <img :src="require('@/assets/images/logAudit-module5-5.jpg')" />
                    <img :src="require('@/assets/images/logAudit-module5-6.jpg')" />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:10}">
              <div class="view">
                <div class="img-box">
                  <img :src="require('@/assets/images/logAudit-module5-1.jpg')" />
                </div>
              </div>
            </el-col>
          </div>
          <div class="module-view">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:10}">
              <div class="view">
                <div class="img-box">
                  <img :src="require('@/assets/images/logAudit-module5-2.jpg')" />
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:14}">
              <div class="view">
                <div class="view-title">
                  <h3>02 精细的日志采集粒度</h3>
                  <p>FINE-GRAINED LOGGING</p>
                </div>
                <div class="infos-box">
                  <p>对比并不具备足够DPI能力的传统网关类设备，神行者日志的突出优势在七层应用日志，如<span>微博、微信、QQ、淘宝账户、论坛贴吧、DNS请求、地理位置</span>等。</p>
                  <div class="tag-box">
                    <img :src="require('@/assets/images/logAudit-module5-7.jpg')" />
                    <img :src="require('@/assets/images/logAudit-module5-8.jpg')" />
                  </div>
                </div>
              </div>
            </el-col>
          </div>
          <div class="module-view">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="view">
                <div class="view-title">
                  <h3>03 更贴近运营需求的输出图表</h3>
                  <p>CHART OF OPERATING REQUIREMENTS</p>
                </div>
                <div class="infos-box">
                  <p>流量流向、用户行为、上网轨迹、TOP目标、域名统计、用户热力分布图等数据输出，为网络精细化运营、大数据系统提供强有力的技术支撑。</p>
                  <div class="infos-img">
                    <img :src="require('@/assets/images/logAudit-module5-3.jpg')" />
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="view">
                <div class="img-box">
                  <img :src="require('@/assets/images/logAudit-module5-4.jpg')" />
                </div>
              </div>
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          神行者大数据平台
        </div>
        <div class="module5-conts">
          <div class="module-view">
              <div class="view">
                <div class="view-title">
                  <h3>事态感知，时延分析</h3>
                  <p>FINE-GRAINED LOGGING</p>
                </div>
                <div class="infos-box">
                  <p>用户动态感知系统和监控等功能，通过大屏用户质量感知系统和拨测系统配合，实时告警知晓各种应用时延，方便运维对路由策略进行优化，防止故障与防范于未然。</p>
                  <div class="infos-img">
                    <img :src="require('@/assets/images/logAudit-module6-1.jpg')" />
                  </div>
                  <div class="clearbox">
                    <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                      <div class="infos-img">
                        <img :src="require('@/assets/images/logAudit-module6-2.jpg')" />
                      </div>
                    </el-col>
                    <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                      <div class="infos-img">
                        <img :src="require('@/assets/images/logAudit-module6-3.jpg')" />
                      </div>
                    </el-col>
                  </div>
                  <div class="clearbox">
                    <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                      <div class="infos-box">
                        <p>可按应用、游戏分类时延、时延参数异常数据一目了然。</p>
                        <div class="infos-img">
                          <img :src="require('@/assets/images/logAudit-module6-4.jpg')" />
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                      <div class="infos-img">
                        <img :src="require('@/assets/images/logAudit-module6-5.jpg')" />
                      </div>
                    </el-col>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          运维监控，参数报表
        </div>
        <div class="module7-conts">
          <img :src="require('@/assets/images/logAudit-module7-1.jpg')" />
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  }
};
</script>
<style lang="scss" scoped>
.clearbox{
  *zoom: 1;
  &::after{
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;
  }
}
.the-banner {
  height: 400px;
  background-image: url("../../../assets/images/logAudit-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.bgbox-gray {
  padding: 50px 10px;
  overflow: hidden;
  background: #f7f7f7;
  box-sizing: border-box;
}
.module-title{
  text-align: center;
  font-size: 24px;
  color: #1f1f1f;
  line-height: 1;
  padding-bottom: 20px;
  position: relative;
  margin-bottom: 50px;
  &::after{
    content: '';
    position: absolute;
    width: 70px;
    height: 4px;
    background: #1f1f1f;
    bottom: 0;
    left: 50%;
    margin-left: -35px;
  }
}
.module-conts {
  padding: 30px 0;
  box-sizing: border-box;
  margin-bottom: 20px;
  overflow: hidden;
}

.module1-conts{
  .view-left{
    padding: 20px;
    box-sizing: border-box;
    h1{
      font-size: 50px;
      color: #1f1f1f;
      font-weight: bold;
    }
    h2{
      font-size: 40px;
      color: #1f1f1f;
      font-weight: 400;
      margin-bottom: 30px;
    }
    p{
      font-size: 14px;
      color: #757575;
      margin-bottom: 30px;
    }
    .line{
      margin-bottom: 20px;
      overflow: hidden;
      span{
        display: inline-block;
        background: #0072d4;
        font-size: 14px;
        color: #fff;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 6px;
      }
      &:nth-of-type(2){
        .line-label{
          height: 60px;
          width: 180px;
          float: left;
          padding-top: 10px;
          box-sizing: border-box;
        }
        .line-info{
          width: 280px;
          height: 60px;
          display: block;
          float: left;
          p{
            font-size: 12px;
            color: #212121;
            line-height: 30px;
            padding-left: 20px;
            box-sizing: border-box;
            position: relative;
            margin: 0;
            &::before{
              content: '';
              display: block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #0072d4;
              position: absolute;
              top: 50%;
              left: 10px;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
  .view-right{
    padding: 0 20px;
    box-sizing: border-box;
    .img-box{
      margin-bottom: 20px;
      img{
        display: block;
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
      }
    }
    p{
      font-size: 14px;
      color: #0066cc;
    }
  }
}

.module2-conts{
  .conts-view{
    width: 100%;
    max-width: 1200px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    .view-left{
      background: url('../../../assets/images/logAudit-module2-icon.png') #3067ba no-repeat;
      background-position: right bottom;
      background-size: 80px;
      padding: 50px 30px;
      box-sizing: border-box;
      h4{
        font-size: 20px;
        color: #fff;
        margin-bottom: 20px;
      }
      p{
        font-size: 16px;
        color: #fff;
      }
    }
    .view-right{
      padding: 60px 30px 10px 30px;
      box-sizing: border-box;
      p{
        font-size: 14px;
        color: #757575;
        line-height: 22px;
        span{
          color: #3067ba;
        }
      }
    }
  }
  .img-box{
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    overflow: hidden;
    padding: 50px 0 0 0;
    box-sizing: border-box;
    .conts{
      width: 120px;
      height: 160px;
      margin: 0 auto 20px auto;
      padding-top: 20px;
      box-sizing: border-box;
      transition: all 0.3s ease-in;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform: translate3d(0,-2px,0);
      }
      img{
        display: block;
        margin: 0 auto 20px auto;
      }
      p{
        font-size: 20px;
        color: #0066cc;
        text-align: center;
      }
    }
  }
  .infos-box{
    p{
      font-size: 16px;
      color: #1f1f1f;
      text-align: center;
      span{
        font-size: 20px;
        color: #3067ba;
      }
    }
  }
}

.module3-conts{
  overflow: hidden;
  .conts-view{
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    img{
      display: block;
      width: 100%;
      margin-bottom: 30px;
    }
    h3{
      font-size: 18px;
      color: #3067ba;
      margin-bottom: 10px;
    }
    p{
      font-size: 14px;
      color: #757575;
      margin-bottom: 30px;
    }
  }
}

.module4-conts{
  overflow: hidden;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  .item{
    padding: 10px;
    box-sizing: border-box;
    .card{
      width: 100%;
      max-width: 300px;
      min-height: 360px;
      margin: 0 auto;
      background: #0f6fcc;
      padding: 40px 20px 10px 20px;
      box-sizing: border-box;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease-in;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(41, 112, 234, 0.5);
        transform: translate3d(0, -2px, 0);
        img{
          transform: rotate3d(1, 1, 1,360deg);
        }
      }
      .tag{
        position: absolute;
        width: 70px;
        height: 70px;
        background: linear-gradient(to top left,transparent 50%, rgba(0,0,0,0.3) 50%);
        color: #eee;
        font-size: 30px;
        font-family: monospace;
        padding-top: 4px;
        padding-left: 12px;
        box-sizing: border-box;
        top: 0;
        left: 0;
      }
      img{
        display: block;
        width: 84px;
        margin: 0 auto 30px auto;
        transition: all 0.3s ease-in;
      }
      h4{
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin-bottom: 25px;
      }
      p{
        font-size: 14px;
        color: #fff;
        span{
          color: #f7e21e;
        }
      }
    }
  }
}

.module5-conts{
  .module-view{
    padding-bottom: 40px;
    overflow: hidden;
    .view{
      padding: 0 20px 20px 20px;
      box-sizing: border-box;
      &:hover{
        .view-title{
          &::after{
            width: 100%;
            background-image:linear-gradient(to left,#46d024,#0066cc);
          }
        }
      }
      .view-title{
        margin-bottom: 20px;
        padding-bottom: 10px;
        box-sizing: border-box;
        position: relative;
        &::before{
          content: '';
          width: 100%;
          max-width: 480px;
          height: 1px;
          background: #cccccc;
          position: absolute;
          bottom: 2px;
        }
        &::after{
          content: '';
          width: 20px;
          max-width: 480px;
          height: 3px;
          background: #1f1f1f;
          position: absolute;
          bottom: 0;
          left: 0;
          transition: all 0.3s;
        }
        h3{
          font-size: 18px;
          color: #1f1f1f;
          margin-bottom: 6px;
        }
        p{
          font-size: 12px;
          color: #757575;
        }
      }
      .infos-box{
        overflow: hidden;
        p{
          font-size: 14px;
          color: #757575;
          margin-bottom: 30px;
          span{
            font-size: 16px;
            color: #5c5c5c;
          }
        }
        .tag-box{
          width: 100%;
          text-align: right;
          img:nth-child(2){
            margin-left: 20px;
          }
        }
        .infos-img{
          img{
            display: block;
            width: 100%;
            max-width: 600px;
            margin: 0 auto 40px auto;
          }
        }
        .clearbox{
          margin-bottom: 20px;
        }
      }
      .img-box{
        img{
          display: block;
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
        }
      }
    }
  }
}

.module7-conts{
  img{
    width: 100%;
    max-width: 1200px;
    display: block;
    margin: 0 auto;
  }
}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/logAudit-banner2.jpg");
  }
  .module1-conts{
    .view-left{
      padding: 0;
      h1{
        font-size: 40px;
      }
      h2{
        font-size: 30px;
      }
    }
    .view-right{
      padding: 0;
    }
  }
  .module2-conts{
    .conts-view{
      .view-left{
        padding: 20px 10px;
      }
      .view-right{
        padding: 20px 10px;
      }
    }
    .img-box{
      padding: 20px 0;
    }
  }
  .module5-conts{
    .module-view{
      .view{
        padding: 0 0 10px 0;
      }
    }
  }
}
</style>